<template>
  <div>
    <div class="banner">
      <img src="@/assets/b1.jpg">
    </div>
    <div class="disp-mob">
      <img src="/assets/images/banner1.png" class="banner">
    </div>
    <ResultBox />
    <div class="banner2">
      <img src="@/assets/b2.png">
    </div>
  </div>
</template>
<script>
import ResultBox from './components/ResultBox.vue'

export default {
  components: {
    ResultBox
  },
  data() {
    return {
      currentDate: null
    }
  },
  created() {
    console.log('pathDate', this.$route.params.pathDate)
  }
}
</script>
<style lang="scss">
.my-result {
  height: 450px;
  margin-bottom: 10px;
}
.iframe-box {
  overflow: hidden;
}
#iframe-l {
  overflow: hidden;
  height: 420px !important;
  margin-left: -210px;
  margin-top: -180px;
  width: 740px;
  max-width: none;
}
.banner {
  text-align: center;
  img {
    width: calc(100% - 4px);
    border-radius: 5px;
    border:2px solid #B11412;
  }
}
.banner2 {
  text-align: center;
  img {
    width: calc(100% - 4px);
  }
}
</style>
